import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { TemperatureOutlined } from '../Icons/TemperatureIcon';
import { StyledButton } from '../ImageViewer.style';

type TemperatureProps = {
  onChange: (data: any) => void;
  value?: boolean;
  disabled?: boolean;
};

export const Temperature: React.FunctionComponent<TemperatureProps> = ({
  onChange,
  value = false,
  disabled = false,
}) => {
  const { t } = useTranslation();
  const handleClick = useCallback(() => {
    onChange({ temperature: !value });
  }, [value, onChange]);

  return (
    <StyledButton
      data-testid="image-controls-temperature"
      title={t('images.measureTemperature', 'Measure Temperature')}
      type={value ? 'primary' : 'default'}
      onClick={handleClick}
      disabled={disabled}
      icon={<TemperatureOutlined />}
    />
  );
};
